module.exports = __webpack_public_path__ + "static/media/authentication-bg-new.98131d25.jpg";